import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useState } from 'react';

import { useGetBookingForAccountQuery } from '#api-bridge/bookingApi.ts';
import { ContactDialog } from '#components/shared/ContactDialog.tsx';
import ErrorFallback from '#components/shared/ErrorFallback.tsx';
import { Checklist } from '#components/welcome/Checklist.tsx';
import { Intro } from '#components/welcome/Intro.tsx';
import { OnboardingProgress } from '#components/welcome/ProgressBar.tsx';
import { hasBookingState } from '#utils/booking.util.ts';

export const WelcomePage = () => {
    const [showContactDialog, setShowContactDialog] = useState(false);
    const { error, data: bookingData, refetch } = useGetBookingForAccountQuery();

    if (error) {
        return <ErrorFallback onRetry={refetch} />;
    }

    if (!bookingData) {
        return <Spinner />;
    }

    const userHasPendingBooking = hasBookingState(bookingData, 'PENDING');

    return (
        <>
            <div className='container fluid-default display-flex flex-column gap-25'>
                {userHasPendingBooking && <OnboardingProgress />}
                <div className='panel panel-default padding-x-50 padding-top-25 padding-bottom-0 shadow-default'>
                    <div className='display-flex flex-wrap column-gap-50 margin-bottom-50'>
                        <Intro userHasBooked={userHasPendingBooking} setShowContactDialog={setShowContactDialog} />
                        <Checklist userHasBooked={userHasPendingBooking} />
                    </div>
                    <img
                        src='https://rio.cloud/fileadmin/Marketplace/RIO/Products/Order_Communication/General/pocket_driver_compilation.png'
                        alt=''
                        className='max-width-1000 margin-x-auto img-responsive'
                    />
                </div>
            </div>
            <ContactDialog show={showContactDialog} onClose={() => setShowContactDialog(false)} />
        </>
    );
};
